export default __webpack_public_path__ + "static/media/ElephantPage2.7c5b9c04.txt";